import React from 'react';
import { Badge } from './ui/badge';
import { skillsData } from '../data/mock';
import { Code2, Server, Cloud, Database, Wrench } from 'lucide-react';

const SkillCategory = ({ title, skills, icon: Icon }) => (
  <div className="p-6 bg-white rounded-xl border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all">
    <div className="flex items-center gap-3 mb-5">
      <div className="p-2 bg-gray-50 rounded-lg">
        <Icon className="w-4 h-4 text-gray-700" />
      </div>
      <h3 className="text-base font-medium text-gray-900">{title}</h3>
    </div>
    <div className="flex flex-wrap gap-2">
      {skills.map((skill) => (
        <Badge
          key={skill}
          variant="secondary"
          className="bg-gray-50 hover:bg-gray-100 text-gray-600 border-0 px-2.5 py-1 text-xs font-normal transition-colors cursor-default"
        >
          {skill}
        </Badge>
      ))}
    </div>
  </div>
);

const Skills = () => {
  const categories = [
    { title: 'Frontend', skills: skillsData.frontend, icon: Code2 },
    { title: 'Backend', skills: skillsData.backend, icon: Server },
    { title: 'Cloud & DevOps', skills: skillsData.cloud, icon: Cloud },
    { title: 'Databases', skills: skillsData.database, icon: Database },
    { title: 'CI/CD & Tools', skills: skillsData.tools, icon: Wrench },
  ];

  return (
    <section id="skills" className="py-20 lg:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <span className="text-sm font-medium text-blue-600 tracking-wide uppercase mb-2 block">
            Skills
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 tracking-tight">
            Technical expertise
          </h2>
        </div>

        {/* Skills Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((category) => (
            <SkillCategory
              key={category.title}
              title={category.title}
              skills={category.skills}
              icon={category.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
